import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  closeButton: ({ theme, props: { size = 24 } = {} }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${size + size * 0.5}px;
    height: ${size + size * 0.5}px;
    border-radius: 50%;
    flex-shrink: 0;

    ${extractTransition((f) => f.cubic, { duration: 330, property: ['background-color'] })}

    &:hover {
      cursor: pointer;
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
} satisfies Styles<{ size: number }>;

export const useStyles = withStyles(styles);
